import * as React from 'react'

import * as Style from './style.css'

import { ArrowLinkButton } from '~/atoms/button/ArrowLinkButton'

import {
  BUTTON_TYPE_PINK,
  BUTTON_TYPE_BLUE,
} from '~/atoms/button/ArrowLinkButton'

export const ContentHelpCenter = (): JSX.Element => {
  return (
    <div className={Style.ContentHelpCenter}>
      <div className={Style.ContentHelpCenterButtonSitter}>
        <ArrowLinkButton
          buttonType={BUTTON_TYPE_PINK}
          accordionTitle="【ベビーシッター】よくあるご質問はコチラ"
          href="/help/about_sitter_unlogin/center_list"
        />
      </div>
      <div className={Style.ContentHelpCenterButtonHousekeeping}>
        <ArrowLinkButton
          buttonType={BUTTON_TYPE_BLUE}
          accordionTitle="【家事サポーター】よくあるご質問はコチラ"
          href="/help/sitter_housekeeping_unlogin/center_list"
        />
      </div>
    </div>
  )
}
